<!-- <template>
  <div>
      <form class="cursor-pointer" @click="addToWishlist(product.id)">
        <i v-if="!product.in_wishlist" class="cursor-pointer wishlit-icon absolute far fa-heart text-3xl text-teal-400"></i>
        <i v-if="product.in_wishlist" class="cursor-pointer wishlit-icon absolute fas fa-heart text-3xl text-teal-400"></i>
      </form>
  </div>
</template>

<script>
export default {
    props: {
        product: Object
    },
    data() {
        return {
            in_wishlist: false
        }
    },
    methods: {
        addToWishlist(id) {
            this.$emit('add-wishlist', id)

            this.product.in_wishlist = true;
        }
    }
}
</script>

<style scoped>
    /* .wishlit-icon {
        top: 15%;
        left: 80%;
    } */

    .wishlit-icon {
        top: 6%;
        left: 83%;
    }

    @media(max-width:450px){
        .wishlit-icon {
        
        top: 3%;
        left: 85%;
        font-size: 20px;
    }  
    }
</style> -->

<template>
    <div>
        <form class="cursor-pointer" @click="addToWishlist(product.id)">
          <i v-if="!product.in_wishlist" class="cursor-pointer wishlit-icon wishlit-icon-2 absolute far fa-heart text-3xl text-teal-400"></i>
          <i v-if="product.in_wishlist" class="cursor-pointer wishlit-icon wishlit-icon-2 absolute fas fa-heart text-3xl text-teal-400"></i>
        </form>
    </div>
  </template>
  
  <script>
  export default {
      props: {
          product: Object
      },
      data() {
          return {
              in_wishlist: false
          }
      },
      methods: {
          addToWishlist(id) {
              this.$emit('add-wishlist', id)
  
              this.product.in_wishlist = true;
          }
      }
  }
  </script>
  
  <style scoped>
      /* .wishlit-icon {
          top: 15%;
          left: 80%;
      } */
  
      .wishlit-icon {
          top:86% ;
      left:80% ;
      width:19px;
      }
  
      .wishlit-icon:hover{
          fill: green;
      }
  
      @media(max-width:450px){
          .wishlit-icon {
          
            top: 88%;
          left: 85%;
          font-size: 20px;
      }  
      }
  </style>